import axios, { AxiosInstance } from 'axios';
import { apiConfig } from '@/config/apiConfig';
import { getVoiceFallbackClient } from './_shared';
import type { SegmentCriteria } from './segments';

// ── Offers (/api/offers) — win-back / loyalty offers (BOOSTT-3172) ──────

export type OfferDiscountType = 'percent' | 'fixed' | 'referral_credit';

export type Offer = {
  id: string;
  campaign_id: string;
  name: string;
  discount_type: OfferDiscountType;
  discount_value: string;
  promo_code?: string | null;
  expiration_date?: string | null;
  eligibility_criteria?: SegmentCriteria | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
};

export type CreateOfferInput = {
  campaign_id: string;
  name: string;
  discount_type?: OfferDiscountType;
  discount_value: string;
  promo_code?: string;
  expiration_date?: string;
  eligibility_criteria?: SegmentCriteria;
};

export type UpdateOfferInput = Partial<Omit<CreateOfferInput, 'campaign_id'>> & { is_active?: boolean };

export async function fetchOffers(campaignId: string, axiosInstance?: AxiosInstance): Promise<Offer[]> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.get<Offer[]>(apiConfig.voiceEndpoints.offers, { params: { campaign_id: campaignId } });
  return response.data;
}

export async function createOffer(input: CreateOfferInput, axiosInstance?: AxiosInstance): Promise<Offer> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.post<Offer>(apiConfig.voiceEndpoints.offers, input);
  return response.data;
}

export async function updateOffer(id: string, input: UpdateOfferInput, axiosInstance?: AxiosInstance): Promise<Offer> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.patch<Offer>(`${apiConfig.voiceEndpoints.offers}/${id}`, input);
  return response.data;
}

export async function deleteOffer(id: string, axiosInstance?: AxiosInstance): Promise<void> {
  const client = axiosInstance || getVoiceFallbackClient();
  await client.delete(`${apiConfig.voiceEndpoints.offers}/${id}`);
}
